module.exports = __webpack_public_path__ + "img/approval.ca332e2e.svg";